import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { useNumericStepInput } from '../numeric-step-input-field.hooks';
import { CustomTextField } from './custom-text-field/custom-text-field.component';

export type NumericStepInputBaseProps = {
  value: string | number;
  onChange: (value: any) => void;
  step: number;
  allowNegative?: boolean;
  allowDecimal?: boolean;
  decrementDisabled?: (value: any) => boolean;
  incrementDisabled?: (value: any) => boolean;
  'data-testid'?: string;
  style?: React.CSSProperties;
} & Partial<NumericFormatProps<any>>;

export const NumericStepInputBase = ({
  value,
  onChange,
  step,
  allowNegative = true,
  allowDecimal = true,
  decrementDisabled,
  incrementDisabled,
  'data-testid': dataTestId = 'NumericStepInput',
  style,
  ...rest
}: NumericStepInputBaseProps) => {
  const { handleDecrement, handleIncrement, dDisabled, iDisabled } =
    useNumericStepInput({
      value,
      onChange,
      step,
      allowNegative,
      decrementDisabled,
      incrementDisabled,
    });

  return (
    <NumericFormat
      value={value}
      onValueChange={({ floatValue }) => {
        if (floatValue !== null && floatValue !== undefined) {
          onChange(floatValue);
        } else {
          onChange(null);
        }
      }}
      customInput={CustomTextField}
      handleIncrement={handleIncrement}
      handleDecrement={handleDecrement}
      dDisabled={dDisabled || value === null || value === undefined}
      iDisabled={iDisabled || value === null || value === undefined}
      allowNegative={allowNegative}
      allowDecimal={allowDecimal}
      style={style}
      data-testid={dataTestId}
      {...rest}
    />
  );
};

export default NumericStepInputBase;
